import { isEmpty } from '../utils/miscellaneous/objectHelpers';
import { createSelector } from 'reselect';

export const selectDashboardLite = state => state.dashboardLite;

export const selectDashboardModels = createSelector(
    [selectDashboardLite],
    dashboardLiteSlice => dashboardLiteSlice.dashboardModels
);

export const selectDashboardModelsEntities = createSelector(
    [selectDashboardModels],
    dashboardModels => dashboardModels.entities
);

export const selectIsDashboardModelsIsLoading = createSelector(
    [selectDashboardModels],
    dashboardModels => dashboardModels.isLoading
);

export const selectSortedDashboardModels = createSelector(
    [selectDashboardModelsEntities],
    entities  =>
        entities.sort((a, b) => parseInt(b.applicationYear) - parseInt(a.applicationYear))
);

const selectPartnerBroker = createSelector(
    [selectDashboardLite],
    (dashboardLiteSlice) => dashboardLiteSlice.partnerBroker
);

export const selectIsLoadingPartnerBroker = createSelector(
    [selectPartnerBroker],
    (partnerBrokers) => partnerBrokers.isLoading
);

export const selectPartner = createSelector(
    [selectPartnerBroker],
    (partnerBrokers) => isEmpty(partnerBrokers.partner) ? null : partnerBrokers.partner
);

export const selectBroker = createSelector(
    [selectPartnerBroker],
    (partnerBrokers) => isEmpty(partnerBrokers.broker) ? null : partnerBrokers.broker
);

